import { Playground } from 'docz';
import { Profile } from "../../../../../src/components/Elements";
import { Title } from "../../../../../src/components/Layout";
import * as React from 'react';
export default {
  Playground,
  Profile,
  Title,
  React
};